import React from 'react';
import './About.css';

import smbristy from '../../assets/smbristy.jpg';
import fiverrtext from '../../assets/Fiverr-text.png';

const About = () => {
  return (
    <section id='about'>
      <div className="container-about">
        <div className="fiver-details">
          <div className="aboutus-section">
            <div className="aboutus-title">
              <h1>About US</h1>
            </div>

            <div className="aboutus-text">
              <span>WebHarvester Agency, led by co-founders Tawhid and Sabrina, is a leading digital marketing agency that specializes in providing high-quality lead generation services. With targeted industry and location-based lead lists, we help businesses globally connect with the right prospects. With a proven track record as the leading B2B lead generation service provider on Fiverr since 2020, we bring a wealth of experience and expertise to the table. In addition to lead generation, we offer administrative data entry and web research services, catering to your diverse business needs.</span>
            </div>
          </div>

          <div className="badge">
            <div className="profile-card">
              <div className="image">
                <img src={smbristy} alt="" loading='lazy' />
              </div>

              <div className="text-data">
                <span className='name'>Sabrina Bristy</span>
                <span className='seller'>Level Two Seller</span>
                <span className="stars">★★★★★</span>

                <a href="https://www.fiverr.com/smbristy" target='blank'>View Fiverr Profile</a>
              </div>
            </div>
          </div>

          <div className="ratings">
            <span className="point">4.9</span>
            <span className="ratings-stars">★★★★★</span>
            <span className="total">400+ Reviews</span>
            <span className="fiverr"><img src={fiverrtext} alt="" loading='lazy' /></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
